<template>
  <router-view />
</template>

<script setup>
import { onMounted, inject } from 'vue'
import { useRouter } from 'vue-router'
import { useMeta, useQuasar } from 'quasar'
import { PushNotifications } from '@capacitor/push-notifications'
import { App } from '@capacitor/app'
import { AppShortcuts } from '@capawesome/capacitor-app-shortcuts'
import { Browser } from '@capacitor/browser'

const staticBaseUrl = import.meta.env.QCLI_STATIC_URL
const $q = useQuasar()
const router = useRouter()
const eventBus = inject('bus')

onMounted(() => {
  useMeta({
    title: 'Start',
    titleTemplate: title => `${title} – VIVAWEST-Kundenportal`
  })
  if (!eventBus.has('onAppMounted')) {
    eventBus.register('onAppMounted', true)
    App.addListener('appStateChange', appState => {
      eventBus.emit('appStateChange', appState)
      if (appState.isActive) {
        eventBus.emit('appResume')
      }
    })
    if ($q.platform.is.nativeMobile) {
      PushNotifications.addListener('pushNotificationActionPerformed', result => {
        if (result.notification?.data?.target) {
          router.push(result.notification.data.target)
        } else if (result.notification?.data?.open) {
          let url = result.notification.data.open
          if (!url.startsWith('http')) {
            url = staticBaseUrl + (url.startsWith('/') ? url.substring(1) : url)
          }
          Browser.open({ url })
        }
      })
      App.addListener('appUrlOpen', event => {
        if (event.url?.includes('://')) {
          const url = new URL(event.url)
          const relativePath = url.pathname
          if ((relativePath.length > 1 || url.searchParams.size > 0) && !relativePath.includes('index.php')) {
            if (relativePath.startsWith('/fileadmin') || relativePath.startsWith('/rest') || relativePath.startsWith('/media') || relativePath.startsWith('/api')) {
              Browser.open({
                url: event.url
              })
            } else {
              router.push({
                path: relativePath,
                query: Object.fromEntries(url.searchParams)
              })
            }
          }
        }
      })
      AppShortcuts.addListener('click', (event) => {
        router.push({
          name: event.shortcutId
        })
      })
    }
  }
})
</script>
